import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  width: 115px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import { Bodytext } from '../../Typography';
import styled from '../../utils/styling/styled-components';
import { InnerPercentContainer, InnerValueContainer } from './styled-components';
var Label = styled(Bodytext)(_templateObject());
var Container = styled.div(_templateObject2());
export var DoughnutContent = function DoughnutContent(_ref) {
  var className = _ref.className,
      defaultContent = _ref.defaultContent,
      selectedIndex = _ref.selectedIndex,
      testId = _ref.testId,
      percentTestId = _ref.percentTestId,
      value = _ref.value,
      label = _ref.label,
      isStatic = _ref.isStatic;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      prevSelectedIndex = _useState4[0],
      setPrevSelectedIndex = _useState4[1];

  useEffect(function () {
    if (selectedIndex !== undefined) {
      setIsHovering(1);
      setPrevSelectedIndex(selectedIndex);
    } else if (isHovering === -1) {
      return;
    } else {
      setIsHovering(0);
    }
  }, [selectedIndex]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(InnerValueContainer, {
    "data-testid": testId,
    animate: !isStatic && isHovering
  }, defaultContent), !isStatic && selectedIndex !== undefined && prevSelectedIndex !== undefined && /*#__PURE__*/React.createElement(InnerPercentContainer, {
    "data-testid": percentTestId,
    animate: isHovering
  }, value, label && /*#__PURE__*/React.createElement(Label, null, label)));
};